import groupBy from "lodash/groupBy";
import {updateQuoteWithSQFTData} from "./sqftQuotesHelper";
import {getWizardPropertiesForFeature} from "../components/canvas/core/controls/resourseCanas";
import {syncQuoteSqftCalcDataWithCart} from "./syncQuoteSqftCalcDataWithCart";
import {getCurrentLayout} from "../../appLayout";

export const updateQuoteSqftFeatureIds = (cartItems) => (dispatch, getState) => {
  const store = getState();
  const { quotes } = store.quotesState;
  const itemsByQuote = groupBy(cartItems, 'currentQuote');

  Object.entries(itemsByQuote).forEach(([quoteId, cartItems]) => {
    const quoteIndex = Number(quoteId);
    const quote = quotes[quoteIndex];
    if (!quote) {
      return;
    }

    const { sqFtCalcData } = quote;

    if (!sqFtCalcData || !sqFtCalcData.countertops) {
      return;
    }

    const syncedQuotes = syncQuoteSqftCalcDataWithCart(quotes, quoteIndex, cartItems, getCurrentLayout());
    const syncedSqFtCalcData = syncedQuotes[quoteIndex].sqFtCalcData;
    const newSqFtCalcData = {
      ...syncedSqFtCalcData,
      countertops: syncedSqFtCalcData.countertops.map(countertop => {
        const linkedCartItems = cartItems.filter(cartItem =>
          (cartItem.sqftId === countertop.id) ||
          (Array.isArray(cartItem.sqftIds) && cartItem.sqftIds.includes(countertop.id))
        );
        return linkedCartItems.reduce((updatedCountertop, cartItem) => {
          const wizardProperties = getWizardPropertiesForFeature(cartItem.cartFeature);
          if (cartItem.partId === countertop.parentPartId) {
            return {
              ...updatedCountertop,
              relatedParentFeatureFromWizardId: wizardProperties.fromWizardId,
              relatedParentFeatureFromWizardStep: wizardProperties.fromWizardStep,
              relatedParentFeatureFromWizardGroupId: wizardProperties.fromWizardGroupId,
            };
          }
          if (cartItem.partId === countertop.partId || !countertop.partId) {
            return {
              ...updatedCountertop,
              fromWizardId: wizardProperties.fromWizardId,
              fromWizardStep: wizardProperties.fromWizardStep,
              fromWizardGroupId: wizardProperties.fromWizardGroupId,
            };
          }
          return updatedCountertop;
        }, countertop);
      })
    };
    updateQuoteWithSQFTData(newSqFtCalcData, quoteIndex);
  });
};

// Remove countertops by sqft id(s) from a quote and persist the updated SQFT data.
// Accepts either a single id or an array of ids.
export const removeFromSqftCalcData = (quoteId, sqftIds) => (dispatch, getState) => {
  // Normalize quote
  const store = getState();
  const { quotes } = store.quotesState;
  const quote = quotes[Number(quoteId)];
  if (!quote) {
    return;
  }

  const { sqFtCalcData } = quote;
  if (!sqFtCalcData || !Array.isArray(sqFtCalcData.countertops)) {
    return;
  }

  // Normalize ids to a Set<string> for fast lookups and safe type coercion
  const ids = Array.isArray(sqftIds) ? sqftIds : [sqftIds];
  const idsSet = new Set(ids.map(id => String(id)));

  // Filter out countertops whose id is listed for removal
  const filteredCountertops = sqFtCalcData.countertops.filter(
    (ct) => !idsSet.has(String(ct.id))
  );

  const newSqFtCalcData = {
    ...sqFtCalcData,
    countertops: filteredCountertops,
  };

  // Persist the change (follows the same pattern as updateQuoteSqftFeatureIds)
  updateQuoteWithSQFTData(newSqFtCalcData, Number(quoteId));
};
